module.exports = __webpack_public_path__ + "img/13.4455c18a.png";